/* cf-rake-powdercoat.js - 12 Oct 2026 (Pete): White and Monument rake panels are powder coated
   ($170+GST fee, already in the -WHT/-MON variant prices) and "we let them know we need 2 weeks to powdercoat".
   Adds that to the rake line on the quote and cart title. Display only: never changes a price or SKU.
   Same shape as the other cf- patches: prototype flag, tryInstall poll, everything in try/catch. */
(function () {
  var NOTE = ' - powder coated, we need 2 weeks to powder coat';
  function tag(item) {
    try {
      if (!item || !/-(MON|WHT)$/.test(String(item.sku || ''))) return;
      ['title', 'item'].forEach(function (k) {
        if (typeof item[k] === 'string' && item[k].indexOf(NOTE) < 0) item[k] += NOTE;
      });
    } catch (e) {}
  }
  var tries = 0;
  function tryInstall() {
    var gc = window.glassCalculator;
    var P = gc && Object.getPrototypeOf(gc);
    if (!P || typeof P.calculateRakedPanelCosts !== 'function') { if (++tries < 80) setTimeout(tryInstall, 250); return; }
    if (P.__cfRakePowderPatched) return;
    var orig = P.calculateRakedPanelCosts;
    P.calculateRakedPanelCosts = function () {
      var r = orig.apply(this, arguments);
      try {
        var c = this.state && this.state.cartItems, b = this.state && this.state.quoteBreakdown;
        if (c && c.length) tag(c[c.length - 1]);
        if (b) b.forEach(function (x) { if (x && x.category === 'Raked Panels') tag(x); });
      } catch (e) {}
      return r;
    };
    P.__cfRakePowderPatched = true;
    console.log('[cf-rake-powdercoat] installed');
  }
  tryInstall();
})();
